import { merge, Stack, Text } from '@fluentui/react';
import React, { useMemo, useState } from 'react';
import { useCallback } from 'react';
import cancelIcon from '../../../assets/icons/svg/cancel.svg';
import saveIcon from '../../../assets/icons/svg/save.svg';
import { useNotificationsManager } from '../../../contexts/notificationContext';
import { ResponsiveSize, useResponsiveSize } from '../../../contexts/responsiveContext';
import { useUserManager } from '../../../contexts/userContext';
import { Data } from '../../../data/Data';
import FormField from '../../FormField';
import FormActionButton from './FormActionButton';

const PasswordForm = (props) => {

    const {
        onCancel = () => null,
        onSave = () => null
    } = props;

    const { confirm, dismiss, extractErrorMessages, inform } = useNotificationsManager();
    const { responsiveSize } = useResponsiveSize();
    const { updateUser } = useUserManager();

    const [currentPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [newPasswordConfirmation, setNewPasswordConfirmation] = useState("");

    const styles = useMemo(
        () => {
            let styles = {
                buttons: {
                    root: {
                        flexDirection: "column",
                        gap: 13
                    }
                },
                error: {
                    root: {
                        color: "red",
                        fontSize: 12,
                        lineHeight: "14px",
                        paddingTop: 4,
                    }
                },
                fields: {
                    root: {
                        gap: 25,
                        marginBottom: 25,
                        marginTop: 15,
                        width: "100%"
                    }
                },
                hint: {
                    root: {
                        fontSize: 11,
                        lineHeight: "13px",
                        textAlign: "center"
                    }
                },
                inner: {
                    root: {
                        alignItems: "center",
                        background: "#ECECEC",
                        marginBottom: 26,
                        padding: "42px 35px",
                        position: "relative",
                    }
                },
                title: {
                    root: {
                        fontSize: 18,
                        fontWeight: 700,
                        lineHeight: "24px",
                    }
                },
            };

            if (responsiveSize >= ResponsiveSize.medium)
                styles = merge(
                    styles,
                    {
                        buttons: {
                            root: {
                                flexBasis: 1,
                                flexDirection: "row",
                                flexGrow: 1,
                            }
                        },
                        inner: {
                            root: {
                                marginBottom: 52,
                                padding: "40px 25%",
                                position: "relative",
                            }
                        },
                    }
                );

            return styles;
        },
        [responsiveSize]
    );

    const disabled = useMemo(() => {
        if (!currentPassword || !newPassword || !newPasswordConfirmation) return true;
        if (currentPassword === newPassword) return true;
        if (newPassword !== newPasswordConfirmation) return true;
        //2811
        //const regex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[()#?!@$%^&*-]).{8,}$/;//20241015 : YD : 2790
        //            /* /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/; */
        //const strongEnough = regex.test(newPassword);
        //if (!strongEnough) return true;

        return false;
    }, [currentPassword, newPassword, newPasswordConfirmation]);

    const savePassword = useCallback(() => {
        const id = inform("Mise à jour du mot de passe en cours...");
        Data._updatePasswordOnline(currentPassword, newPassword, newPasswordConfirmation).then(response => {
            if (response.codeRetour === 0) {
                const { idContactChiffre } = response.reponseAPIobjet;
                updateUser({ idContactChiffre });
                sessionStorage.setItem("idContact", idContactChiffre);
                confirm("Mise à jour du mot de passe effectuée avec succès");
                onSave();
            }
            else extractErrorMessages(response);
            dismiss(id);
        });
    }, [confirm, currentPassword, dismiss, extractErrorMessages, inform, newPassword, newPasswordConfirmation, onSave, updateUser]);

    return <Stack>
        <Stack styles={styles.inner}>

            <Text styles={styles.title}>Modifier mon mot de passe :</Text>

            <Stack styles={styles.fields}>
                <FormField
                    hideInput
                    onChange={(event, newValue) => setCurrentPassword(newValue)}
                    placeholder="Mot de passe actuel"
                    value={currentPassword}
                />
                <FormField
                    hideInput
                    onChange={(event, newValue) => setNewPassword(newValue)}
                    placeholder="Nouveau mot de passe"
                    value={newPassword}
                />
                <Stack>
                    <FormField
                        hideInput
                        onChange={(event, newValue) => setNewPasswordConfirmation(newValue)}
                        placeholder="Confirmation du nouveau mot de passe"
                        value={newPasswordConfirmation}
                    />
                    {!!newPassword && !!newPasswordConfirmation && newPassword !== newPasswordConfirmation &&
                        <Text styles={styles.error}>Les nouveaux mots de passe ne sont pas identiques</Text>
                    }
                </Stack>
            </Stack>

            <Text styles={styles.hint}>Le nouveau mot de passe doit contenir au moins 8 caractères, dont au moins 1 majuscule, 1 minuscule, 1 chiffre et 1 caractère spécial.</Text>

        </Stack>

        <Stack styles={styles.buttons}>
            <FormActionButton
                disabled={disabled}
                onClick={savePassword}
                primary
                src={saveIcon}
                text="Enregistrer mes modifications"
            />
            <FormActionButton src={cancelIcon} text="Annuler mes modification" onClick={onCancel} />
        </Stack>

    </Stack>;

};

export default PasswordForm;